import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TabModel } from '../model/tab.model';

@Injectable({
  providedIn: 'root',
})

export class TabNavigationService {
  public activatedTab$: BehaviorSubject<TabModel> = new BehaviorSubject(new TabModel());

  /**
   * Marks the pending announcement as consumed. The subject replays its last value to every new
   * subscriber, so an announcement left in place would hijack the next visit to that page.
   */
  clearActivatedTab(): void {
    this.activatedTab$.next(new TabModel());
  }
}
